import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row, RSelect } from '../../../components/Component';
import { Link } from 'react-router-dom';
import * as app_consts from "../../../utils/app_consts";
import AuthTenantNoData from '../../error/AuthTenantNoData';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenants_goods_received_list, loading_retrieve_tenants_goods_received_list, reset_retrieve_tenants_goods_received_list, success_retrieve_tenants_goods_received_list } from '../../../reducers/auth_tenant/retrieve_tenants_goods_received_list_Slice';
import { ADD_TENANT_GOODS_RECEIVED_ERROR_MSG, ADD_TENANT_GOODS_RECEIVED_PRODUCTS_ERROR_MSG, ADD_TENANT_GOODS_RECEIVED_PRODUCTS_SUCCESS_MSG, ADD_TENANT_GOODS_RECEIVED_SUCCESS_MSG, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_ERROR_MSG, RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_SUCCESS_MSG, RETRIEVE_TENANT_GOODS_RECEIVED_ERROR_MSG, RETRIEVE_TENANT_GOODS_RECEIVED_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { ADD_TENANT_GOODS_RECEIVED_API, RETRIEVE_TENANT_PRODUCTS_BY_STATUS_API, RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_API, RETRIEVE_TENANT_GOODS_RECEIVED_API, RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API, TENANT_ADD_PRODUCTS_AND_COMPLETE_GOODS_RECEIVED_API } from '../../../api/api_data';
import { useSelector } from 'react-redux';
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import { Alert, Badge, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import TextInput from '../../components/inputs/TextInput';
import { fail_add_tenant_goods_received, loading_add_tenant_goods_received, reset_add_tenant_goods_received, success_add_tenant_goods_received } from '../../../reducers/auth_tenant/add_tenant_goods_received_Slice';
import moment from 'moment';
import { fail_retrieve_goods_received_details, loading_retrieve_goods_received_details, reset_retrieve_goods_received_details, success_retrieve_goods_received_details } from '../../../reducers/auth_tenant/retrieve_goods_received_details_Slice';
import CardTabs from '../../components/cards/CardTabs';
import { fail_retrieve_products, loading_retrieve_products, reset_retrieve_products, success_retrieve_products } from '../../../reducers/auth_tenant/retrieve_products_Slice';
import { fail_retrieve_warehouse_sites, loading_retrieve_warehouse_sites, reset_retrieve_warehouse_sites, success_retrieve_warehouse_sites } from '../../../reducers/auth_tenant/retrieve_warehouse_sites_Slice';
import { fail_add_products_to_goods_received_and_complete_goods_received, loading_add_products_to_goods_received_and_complete_goods_received, reset_add_products_to_goods_received_and_complete_goods_received, success_add_products_to_goods_received_and_complete_goods_received } from '../../../reducers/auth_tenant/add_products_to_goods_received_and_complete_goods_received_Slice';
import { PDFViewer } from '@react-pdf/renderer';
import GoodsReceivedPDF from '../../../components/pdf/GoodsReceivedPDF';

const inital_add_goods_received_state = { supplier: "", transporter: "", truck_driver_name: "", license_plate: "", trailer_one: "", trailer_two: "", invoice_ref_no: "", unit_value: "", total_value: "" };

const GoodsReceievedManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [goods_received_data, setGoodsReceivedData] = useState([]);
  const [sm, updateSm] = useState(false);
  const [add_goods_received_modal, setAddGoodsReceivedModal] = useState(false);
  const [add_goods_receieved_loading, setAddGoodsReceivedModalLoading] = useState(false);
  const [add_goods_receieved_error, setAddGoodsReceivedModalError] = useState("");
  const [add_goods_receieved_formData, setAddGoodsReceivedModalFormData] = useState(inital_add_goods_received_state);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [view_goods_received_details_modal, setViewGoodsReceivedDetailsModal] = useState(false);
  const [retrieve_goods_received_details_loading, setRetrieveGoodsReceivedDetailsLoading] = useState(false);
  const [retrieve_goods_received_details_error, setRetrieveGoodsReceivedDetailsError] = useState("");
  const [retrieve_goods_received_details_data, setRetrieveGoodsReceivedDetailsData] = useState([]);
  const [viewGoodsReceivedDetailsActiveCardTab, setViewGoodsReceivedDetailsActiveCardTab] = useState("Goods Received Info");
  const [add_products_to_goods_received_error, setAddProductsToGoodsReceivedError] = useState("");
  const [add_products_to_goods_received_loading, setAddProductsTOGoodsReceivedLoading] = useState(false);
  const [open_add_products_to_goods_received_confirmation, setAddProductsTOGoodsReceivedConfirmation] = useState(false);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");


  const [goodsReceivedProductItems, setGoodsReceivedProductItems] = useState(retrieve_goods_received_details_data?.products || []);

  const [warehouse_sites, setWarehouseSites] = useState();
  const [products, setProducts] = useState([]);
  const [newGoodsReceivedItem, setNewGoodsReceivedItem] = useState({
    product_id: "",
    color: "",
    size: "",
    units: "",
    product_name: "",
    category: "",
    warehouse_site_id: "",
    warehouse_name: "",
    total_value: "",
    unit_value: ""
  });

  const [goods_received_categories, setGoodsReceivedCategories] = useState([]);
  const [goods_received_products, setGoodsReceivedProducts] = useState([]);
  const [goods_received_colors, setGoodsReceivedColors] = useState([]);
  const [goods_received_sizes, setGoodsReceivedSizes] = useState([]);

  const dispatch = useDispatch();


  useEffect(() => {
    retrieve_goods_received();
  }, []);

  const retrieve_goods_received = () => {
    setError("");
    setLoading(true);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenants_goods_received_list, success_retrieve_tenants_goods_received_list, fail_retrieve_tenants_goods_received_list, RETRIEVE_TENANT_GOODS_RECEIVED_ERROR_MSG, RETRIEVE_TENANT_GOODS_RECEIVED_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_GOODS_RECEIVED_API}`));
  };

  // Listener
  const retrieve_tenants_goods_received_list_listener = useSelector((state) => state.retrieve_tenants_goods_received_list.retrieve_tenants_goods_received_list);

  useEffect(() => {
    if (retrieve_tenants_goods_received_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenants_goods_received_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenants_goods_received_list_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenants_goods_received_list_listener.message);
          messageToast(retrieve_tenants_goods_received_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenants_goods_received_list_listener.status === app_consts.SUCCESS)
        {
          setGoodsReceivedData(retrieve_tenants_goods_received_list_listener.data);
          setCurrentPageData(retrieve_tenants_goods_received_list_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenants_goods_received_list());
      }
    }
  }, [retrieve_tenants_goods_received_list_listener]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_goods_received(searchTerm);
  }, [searchTerm]);

  const filtered_goods_received = (searchItem) => {
    if (searchItem)
    {
      let displayedGoodsReceived;

      displayedGoodsReceived = goods_received_data?.filter((item) => {
        const combinedParams = [
          item?.license_plate,
          item.goods_received_ref_no,
          item.supplier,
          item.transporter,
          item.invoice_ref_no,
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedGoodsReceived);
    } else
    {
      setCurrentPageData(goods_received_data);
    }
  };


  const open_add_goods_received_modal = () => {
    setAddGoodsReceivedModal(true);
    setAddGoodsReceivedModalFormData(inital_add_goods_received_state);
  };

  const close_add_goods_received_modal = () => {
    setAddGoodsReceivedModal(false);
    setAddGoodsReceivedModalFormData(inital_add_goods_received_state);
  };

  // Handle Change Function
  const handleChange = (e) => {
    setAddGoodsReceivedModalFormData({ ...add_goods_receieved_formData, [e.target.name]: e.target.value });
  };

  const handleSubmitAddGoodsReceived = () => {
    setAddGoodsReceivedModalError("");
    // Dispatch 
    dispatch(tenant_auth_actions_helper(loading_add_tenant_goods_received, success_add_tenant_goods_received, fail_add_tenant_goods_received, ADD_TENANT_GOODS_RECEIVED_ERROR_MSG, ADD_TENANT_GOODS_RECEIVED_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_TENANT_GOODS_RECEIVED_API}`, add_goods_receieved_formData));
  };

  // Listener
  const add_tenant_goods_received_listener = useSelector((state) => state.add_tenant_goods_received.add_tenant_goods_received);

  useEffect(() => {
    if (add_tenant_goods_received_listener.status !== app_consts.IDLE)
    {
      if (add_tenant_goods_received_listener.status === app_consts.LOADING)
      {
        setAddGoodsReceivedModalLoading(true);
        setAddGoodsReceivedModalError("");
      } else
      {
        setAddGoodsReceivedModalLoading(false);
        if (add_tenant_goods_received_listener.status === app_consts.FAIL)
        {
          setAddGoodsReceivedModalError(add_tenant_goods_received_listener.message);
          messageToast(add_tenant_goods_received_listener.message, app_consts.FAIL);
        } else if (add_tenant_goods_received_listener.status === app_consts.SUCCESS)
        {
          messageToast(ADD_TENANT_GOODS_RECEIVED_SUCCESS_MSG, app_consts.SUCCESS);
          retrieve_goods_received();
          close_add_goods_received_modal();
        }
        dispatch(reset_add_tenant_goods_received());
      }
    }
  }, [add_tenant_goods_received_listener]);


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const open_view_goods_received_details_modal = (goods_received_ref_no) => {
    setViewGoodsReceivedDetailsModal(true);
    setRetrieveGoodsReceivedDetailsLoading(true);
    setRetrieveGoodsReceivedDetailsError("");
    setRetrieveGoodsReceivedDetailsError("");
    setGoodsReceivedProductItems([]);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_goods_received_details, success_retrieve_goods_received_details, fail_retrieve_goods_received_details, RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_ERROR_MSG, RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_API}/${goods_received_ref_no}`));
    // Retrieve Active Products
    dispatch(tenant_auth_actions_helper(loading_retrieve_products, success_retrieve_products, fail_retrieve_products, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCTS_BY_STATUS_API}/${app_consts.ACTIVE}`));
    // Retrieve Active Warehouse Site
    dispatch(tenant_auth_actions_helper(loading_retrieve_warehouse_sites, success_retrieve_warehouse_sites, fail_retrieve_warehouse_sites, RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API}/${app_consts.ACTIVE}`));
  };



  // Listener
  const retrieve_goods_received_details_listener = useSelector((state) => state.retrieve_goods_received_details.retrieve_goods_received_details);

  useEffect(() => {
    if (retrieve_goods_received_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_goods_received_details_listener.status === app_consts.LOADING)
      {
        setRetrieveGoodsReceivedDetailsLoading(true);
        setRetrieveGoodsReceivedDetailsError("");
      } else
      {
        if (retrieve_goods_received_details_listener.status === app_consts.FAIL)
        {
          setRetrieveGoodsReceivedDetailsLoading(false);
          setRetrieveGoodsReceivedDetailsError(retrieve_goods_received_details_listener.message);
          messageToast(retrieve_goods_received_details_listener.message, app_consts.FAIL);
        } else if (retrieve_goods_received_details_listener.status === app_consts.SUCCESS)
        {
          setRetrieveGoodsReceivedDetailsData(retrieve_goods_received_details_listener.data);
          const timer = setTimeout(() => {
            setRetrieveGoodsReceivedDetailsLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_goods_received_details());
      }
    }
  }, [retrieve_goods_received_details_listener]);

  // Listen
  const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

  useEffect(() => {
    if (retrieve_products_listener.status !== app_consts.IDLE)
    {
      if (retrieve_products_listener.status === app_consts.LOADING)
      {
        console.log("Products Loading");
      } else
      {
        if (retrieve_products_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_products_listener.message, app_consts.FAIL);
        } else if (retrieve_products_listener.status === app_consts.SUCCESS)
        {
          return_products_categories(retrieve_products_listener.data);
          setProducts(retrieve_products_listener.data);
        }
        dispatch(reset_retrieve_products());
      }
    }
  }, [retrieve_products_listener]);

  // Grouping Warehouse Sites
  const return_products_categories = (products_data) => {
    const uniqueCategories = new Set();

    const prods = products_data?.reduce((acc, item) => {
      const category = item?.category?.trim();

      if (category && !uniqueCategories.has(category))
      {
        uniqueCategories.add(category);
        acc.push({ label: category, value: item.category });
      }

      return acc;
    }, []);

    setGoodsReceivedCategories(prods);
  };

  // Listen
  const retrieve_warehouse_sites_listener = useSelector((state) => state.retrieve_warehouse_sites.retrieve_warehouse_sites);

  useEffect(() => {
    if (retrieve_warehouse_sites_listener.status !== app_consts.IDLE)
    {
      if (retrieve_warehouse_sites_listener.status === app_consts.LOADING)
      {
        console.log("Warehouse Sites Loading");
      } else
      {
        if (retrieve_warehouse_sites_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_warehouse_sites_listener.message, app_consts.FAIL);
        } else if (retrieve_warehouse_sites_listener.status === app_consts.SUCCESS)
        {
          return_warehouse_sites(retrieve_warehouse_sites_listener.data);
        }
        dispatch(reset_retrieve_warehouse_sites());
      }
    }
  }, [retrieve_warehouse_sites_listener]);

  // Grouping Warehouse Sites
  const return_warehouse_sites = (sites) => {
    const ware_sites = sites?.map((item) => {
      return { label: item?.name, value: item?.id };
    });
    setWarehouseSites(ware_sites);
  };

  const close_view_goods_received_details_modal = () => {
    setViewGoodsReceivedDetailsModal(false);
    setRetrieveGoodsReceivedDetailsError("");
    setRetrieveGoodsReceivedDetailsData([]);
    setGoodsReceivedProductItems([]);
  };

  // Card Tabs
  const view_goods_received_details_tabs = [
    {
      tabName: "Goods Received Info"
    },
    {
      tabName: "Products"
    },
    {
      tabName: "History"
    },
    {
      tabName: "PDF"
    }
  ];

  const removeOrderItem = (id) => {
    setGoodsReceivedProductItems(goodsReceivedProductItems.filter(item => item.id !== id));
  };

  const getSelectedOption = (value, options) => {
    return options?.find(option => option.value === value) || null;
  };

  const handleWarehouseSiteSelect = (value) => {

    setGoodsReceivedProducts([]);
    setGoodsReceivedColors([]);
    setGoodsReceivedSizes([]);

    setNewGoodsReceivedItem({ ...newGoodsReceivedItem, warehouse_site_id: value, product_id: "", color: "", size: "", units: "", product_name: "", category: "", warehouse_name: "" });
  };

  const handleCategorySelect = (value) => {

    const products_data = products?.filter((item) => {
      return item?.category?.trim() === value?.trim();
    });


    const products_map = products_data?.map((item) => {
      return { value: item?.id, label: item?.name };
    });

    setGoodsReceivedProducts(products_map);
    setGoodsReceivedColors([]);
    setGoodsReceivedSizes([]);

    setNewGoodsReceivedItem({ ...newGoodsReceivedItem, product_id: "", color: "", size: "", units: "", product_name: "", category: value, warehouse_name: "" });
  };

  useEffect(() => {
  }, [newGoodsReceivedItem]);

  const handleGoodsReceivedCProductSelect = (value) => {


    const products_data = products?.find(item =>
      item?.id === value &&
      item?.category?.trim() === newGoodsReceivedItem?.category?.trim()
    );

    console.log(products_data);

    let product_name;

    if (products_data)
    {
      product_name = products_data?.name;
    }

    const colors = products_data?.colors?.map((color) => {
      return { value: color, label: color };
    });

    setGoodsReceivedColors(colors);
    setGoodsReceivedSizes([]);

    setNewGoodsReceivedItem({ ...newGoodsReceivedItem, product_id: value, color: "", size: "", units: "", product_name: product_name });
  };

  const handleGoodsReceivedColorSelect = (value) => {

    const products_data = products?.find(item =>
      item?.category?.trim() === newGoodsReceivedItem?.category?.trim() &&
      item?.id === newGoodsReceivedItem?.product_id &&
      item?.colors?.includes(value)
    );

    const sizes = products_data?.packet_sizes?.map((sizes) => {
      return { value: sizes, label: sizes };
    });

    setGoodsReceivedSizes(sizes);

    setNewGoodsReceivedItem({ ...newGoodsReceivedItem, color: value, size: "", units: "" });
  };

  const handleeGoodsReceivedSizeSelect = (value) => {

    setNewGoodsReceivedItem({ ...newGoodsReceivedItem, size: value, units: "" });

  };

  const add_products_to_goods_received = () => {
    if (!newGoodsReceivedItem?.product_id || !newGoodsReceivedItem?.size || !newGoodsReceivedItem?.color || !newGoodsReceivedItem?.units || !newGoodsReceivedItem?.product_name || !newGoodsReceivedItem?.warehouse_site_id || !newGoodsReceivedItem?.unit_value || !newGoodsReceivedItem?.total_value) return;

    // Check for Duplicates
    const isDuplicate = goodsReceivedProductItems?.find((item) => {
      return item?.name === newGoodsReceivedItem.product_name && item?.product_id === newGoodsReceivedItem.product_id && item?.color === newGoodsReceivedItem.color && item?.size === newGoodsReceivedItem?.size && item?.size === newGoodsReceivedItem?.warehouse_site_id;
    });


    const warehouse_name = warehouse_sites.find((site) => site.value === newGoodsReceivedItem?.warehouse_site_id);

    if (isDuplicate)
    {
      messageToast(`Duplicate Entry of ${newGoodsReceivedItem.product_name} at Warehouse ${warehouse_name.label}`, app_consts.SUCCESS);
    }
    else
    {
      // Retrieve Category
      const product = products?.find((item) => {
        return item?.id === newGoodsReceivedItem.product_id && item?.colors?.includes(newGoodsReceivedItem.color) && item?.packet_sizes?.includes(newGoodsReceivedItem?.size);
      });

      setGoodsReceivedProductItems([...goodsReceivedProductItems, { ...newGoodsReceivedItem, category: product?.category, warehouse_name: warehouse_name.label, id: Date.now() }]);
      setNewGoodsReceivedItem({
        product_id: "",
        color: "",
        size: "",
        units: "",
        name: "",
        category: "",
        total_value: "",
        unit_value: ""
      });

      setGoodsReceivedProducts([]);
      setGoodsReceivedColors([]);
      setGoodsReceivedSizes([]);
    }

  };

  const handleAddProductsAndConfirmGoodsReceived = () => {
    setAddProductsToGoodsReceivedError("");
    // Dispatch Data
    const dispatch_data = { products: goodsReceivedProductItems, goods_received_ref_no: retrieve_goods_received_details_data?.goods_received_ref_no };
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_products_to_goods_received_and_complete_goods_received, success_add_products_to_goods_received_and_complete_goods_received, fail_add_products_to_goods_received_and_complete_goods_received, ADD_TENANT_GOODS_RECEIVED_PRODUCTS_ERROR_MSG, ADD_TENANT_GOODS_RECEIVED_PRODUCTS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_ADD_PRODUCTS_AND_COMPLETE_GOODS_RECEIVED_API}`, dispatch_data));
  };

  // Listener
  const add_products_to_goods_received_and_complete_goods_received_listener = useSelector((state) => state.add_products_to_goods_received_and_complete_goods_received.add_products_to_goods_received_and_complete_goods_received);

  useEffect(() => {
    if (add_products_to_goods_received_and_complete_goods_received_listener.status !== app_consts.IDLE)
    {
      if (add_products_to_goods_received_and_complete_goods_received_listener.status === app_consts.LOADING)
      {
        setAddProductsTOGoodsReceivedLoading(true);
        setAddProductsToGoodsReceivedError("");
      } else
      {
        setAddProductsTOGoodsReceivedLoading(false);
        if (add_products_to_goods_received_and_complete_goods_received_listener.status === app_consts.FAIL)
        {
          setAddProductsToGoodsReceivedError(add_products_to_goods_received_and_complete_goods_received_listener.message);
          messageToast(add_products_to_goods_received_and_complete_goods_received_listener.message, app_consts.FAIL);
        } else if (add_products_to_goods_received_and_complete_goods_received_listener.status === app_consts.SUCCESS)
        {
          messageToast(ADD_TENANT_GOODS_RECEIVED_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
          setRetrieveGoodsReceivedDetailsData(add_products_to_goods_received_and_complete_goods_received_listener.data);
          retrieve_goods_received();
        }
        setAddProductsTOGoodsReceivedConfirmation(false);
        dispatch(reset_add_products_to_goods_received_and_complete_goods_received());
      }
    }
  }, [add_products_to_goods_received_and_complete_goods_received_listener]);

  const items = retrieve_goods_received_details_data?.status === app_consts.GOODS_RECEIVED_LOWER
    ? retrieve_goods_received_details_data?.products || []
    : goodsReceivedProductItems || [];

  const totalUnits = items.reduce((acc, item) => acc + (parseFloat(item?.units) || 0), 0);
  const totalValue = items.reduce((acc, item) => acc + (parseFloat(item?.total_value) || 0), 0);


  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Goods Received` : "Goods Received"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Goods Received</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Goods Received ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_goods_received();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Goods Received"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_GOODS_RECEIVED)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_add_goods_received_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_add_goods_received_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Goods Received</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Goods Received..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      goods_received_data && goods_received_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">GRN No.</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Invoice Ref No.</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Transporter</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Total Products</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Total Value</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Date Created</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head* */}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to="#" onClick={(e) => { e.preventDefault(); open_view_goods_received_details_modal(item?.goods_received_ref_no); }}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.goods_received_ref_no || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.supplier || "--"}</span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.invoice_ref_no || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.transporter || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.products_length || 0}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.total_value ? `${parseFloat(item?.total_value)?.toFixed(2)} ZMW` : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.GOODS_RECEIVED_LOWER
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <Link to="#" onClick={(e) => { e.preventDefault(); open_view_goods_received_details_modal(item?.goods_received_ref_no); }}>
                                        <div className="tb-odr-btns d-none d-sm-inline">
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </div>
                                        <Button className="btn-pd-auto d-sm-none">
                                          <Icon name="chevron-right"></Icon>
                                        </Button>
                                      </Link>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Goods Received Found"} />
                        </>
                    }
                  </>
              }
              {/* Add Goods Received Modal */}

              < Modal isOpen={add_goods_received_modal} className="modal-dialog-centered" size={"lg"} >
                <ModalHeader toggle={add_goods_receieved_loading ? "" : close_add_goods_received_modal}>Add Goods Received</ModalHeader>
                <ModalBody>
                  <Row className="g-4">
                    <TextInput
                      label="Supplier"
                      type="text"
                      id_val="supplier"
                      value={add_goods_receieved_formData?.supplier}
                      colSize="6"
                      name="supplier"
                      required
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="Invoice/Delivery Ref No"
                      type="text"
                      id_val="invoice_ref_no"
                      value={add_goods_receieved_formData?.invoice_ref_no}
                      colSize="6"
                      name="invoice_ref_no"
                      required
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="Transporter"
                      type="text"
                      id_val="transporter"
                      value={add_goods_receieved_formData?.transporter}
                      colSize="6"
                      name="transporter"
                      required
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="Driver Name"
                      type="text"
                      id_val="truck_driver_name"
                      value={add_goods_receieved_formData?.truck_driver_name}
                      colSize="6"
                      name="truck_driver_name"
                      required
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="License Plate"
                      type="text"
                      id_val="license_plate"
                      value={add_goods_receieved_formData?.license_plate}
                      colSize="6"
                      name="license_plate"
                      required
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="Trailer One"
                      type="text"
                      id_val="trailer_one"
                      value={add_goods_receieved_formData?.trailer_one}
                      colSize="6"
                      name="trailer_one"
                      handleChange={handleChange}
                    />
                    <TextInput
                      label="Trailer Two"
                      type="text"
                      id_val="trailer_two"
                      value={add_goods_receieved_formData?.trailer_two}
                      colSize="6"
                      name="trailer_two"
                      handleChange={handleChange}
                    />
                    {add_goods_receieved_error && (
                      <div className="mb-3 w-100">
                        <Alert color="danger" className="alert-icon">
                          <Icon name="alert-circle" /> {add_goods_receieved_error}{" "}
                        </Alert>
                      </div>
                    )}
                    <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                      <Button onClick={handleSubmitAddGoodsReceived} disabled={add_goods_receieved_loading || !(add_goods_receieved_formData?.supplier && add_goods_receieved_formData?.truck_driver_name && add_goods_receieved_formData?.license_plate && add_goods_receieved_formData?.invoice_ref_no)} color="primary">
                        {add_goods_receieved_loading ? <Spinner size="sm" color="light" /> : "Add Goods Received"}
                      </Button>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>

              {/* Modal for Viewing Details */}
              < Modal isOpen={view_goods_received_details_modal} className="modal-dialog-centered" size={"xl"} fullscreen >
                <ModalHeader toggle={retrieve_goods_received_details_loading ? "" : close_view_goods_received_details_modal}>Goods Received Details</ModalHeader>
                <ModalBody>
                  {
                    retrieve_goods_received_details_loading ?
                      <>
                        <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Goods Received Details..." />
                      </>
                      :
                      <>
                        {
                          retrieve_goods_received_details_error ?
                            <>
                              <AuthTenantPageError tenant_info={tenant_info} error_message={retrieve_goods_received_details_error} />
                            </>
                            :
                            <>
                              {
                                retrieve_goods_received_details_data && (retrieve_goods_received_details_data?.length > 0 || retrieve_goods_received_details_data !== null) ?
                                  <>
                                    <Block>
                                      <CardTabs cardTabs={view_goods_received_details_tabs} activeCardTab={viewGoodsReceivedDetailsActiveCardTab} setActiveCardTab={setViewGoodsReceivedDetailsActiveCardTab} />
                                    </Block>
                                    {
                                      viewGoodsReceivedDetailsActiveCardTab === "Goods Received Info" && (
                                        <>
                                          <div className="card-inner bg-white">
                                            <Block>
                                              <BlockHead>
                                                <BlockTitle tag="h5">Goods Received Info</BlockTitle>
                                              </BlockHead>
                                              <div className="profile-ud-list">
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Goods Received Ref No</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.goods_received_ref_no || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Invoice/Ref No</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.invoice_ref_no || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Supplier</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.supplier || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Transporter</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.transporter || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Driver Name</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.truck_driver_name || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">License Plate</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.license_plate || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Trailer One</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.trailer_one || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Trailer Two</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.trailer_two || "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Date Created</span>
                                                    <span className="profile-ud-value">{retrieve_goods_received_details_data?.inserted_at ? moment(retrieve_goods_received_details_data?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </div>
                                                </div>
                                                <div className="profile-ud-item">
                                                  <div className="profile-ud wider">
                                                    <span className="profile-ud-label">Status</span>
                                                    <span className="profile-ud-value">
                                                      <span className="tb-odr-status">
                                                        <Badge
                                                          color={
                                                            retrieve_goods_received_details_data?.status === app_consts.GOODS_RECEIVED_LOWER
                                                              ? "success"
                                                              : "warning"
                                                          }
                                                          className="badge-dot"
                                                        >
                                                          {retrieve_goods_received_details_data?.status ? formatToSentenceCase(retrieve_goods_received_details_data?.status)?.toUpperCase() : "--"}
                                                        </Badge>
                                                      </span></span>
                                                  </div>
                                                </div>
                                              </div>
                                            </Block>
                                          </div>
                                        </>
                                      )
                                    }
                                    {
                                      viewGoodsReceivedDetailsActiveCardTab === "Products" && (
                                        <>
                                          <div className="card-inner bg-white">
                                            <Block>
                                              <BlockHead>
                                                <BlockTitle tag="h5">Products</BlockTitle>
                                              </BlockHead>
                                              {add_products_to_goods_received_error && (
                                                <div className="mb-3 w-100">
                                                  <Alert color="danger" className="alert-icon">
                                                    <Icon name="alert-circle" /> {add_products_to_goods_received_error}{" "}
                                                  </Alert>
                                                </div>
                                              )}
                                              <BlockBetween>
                                                {
                                                  retrieve_goods_received_details_data?.status === app_consts.OFFLOADING_GOODS_LOWER && goodsReceivedProductItems?.length > 0 && (
                                                    <>
                                                      <Button color="primary"
                                                        size="sm" onClick={() => setAddProductsTOGoodsReceivedConfirmation(!open_add_products_to_goods_received_confirmation)}>Add Products</Button>
                                                    </>
                                                  )
                                                }
                                              </BlockBetween>
                                              {/* Totals Summary */}
                                              <div className="mb-2 p-2 bg-light rounded d-flex justify-content-start align-items-center">
                                                <div className="me-3">
                                                  <span className="fw-bold">Quantity Total: {formatNumber(totalUnits)} Units</span>
                                                </div>
                                                <div className="ms-3">
                                                  <span className="fw-bold">Value Total: {formatNumber(totalValue)} ZMW</span>
                                                </div>
                                              </div>
                                              <div className="nk-tb-list is-separate is-medium mb-3">
                                                <DataTableHead className="nk-tb-item">
                                                  <DataTableRow size="lg"><span className="sub-text">Warehouse</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Brand</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Color</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Units</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Unit Value (ZMW)</span></DataTableRow>
                                                  <DataTableRow size="lg"><span className="sub-text">Total Value</span></DataTableRow>
                                                </DataTableHead>
                                                {
                                                  retrieve_goods_received_details_data?.status === app_consts.GOODS_RECEIVED_LOWER ?
                                                    <>
                                                      {retrieve_goods_received_details_data?.products?.length > 0 &&
                                                        retrieve_goods_received_details_data?.products?.map((item) => (
                                                          <DataTableItem key={item.id}>
                                                            <DataTableRow><span className="tb-lead">{item?.warehouse_name || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.product_name || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.units || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.unit_value || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.total_value || "--"}</span></DataTableRow>
                                                          </DataTableItem>
                                                        ))}
                                                    </>
                                                    :
                                                    <>
                                                      {goodsReceivedProductItems.length > 0 &&
                                                        goodsReceivedProductItems.map((item) => (
                                                          <DataTableItem key={item.id}>
                                                            <DataTableRow><span className="tb-lead">{item?.warehouse_name || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-lead">{item?.product_name || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.unit_value || "0"}</span></DataTableRow>
                                                            <DataTableRow><span className="tb-sub">{item?.total_value || "0"}</span></DataTableRow>
                                                            <DataTableRow className="nk-tb-col-tools">
                                                              <Button color="danger" size="sm" onClick={() => removeOrderItem(item.id)}>Remove</Button>
                                                            </DataTableRow>
                                                          </DataTableItem>
                                                        ))}

                                                      {/* Add New Order Item */}
                                                      <DataTableItem>
                                                        <DataTableRow>
                                                          <RSelect
                                                            options={warehouse_sites?.map((p) => {
                                                              return (
                                                                {
                                                                  label: p?.label,
                                                                  value: p?.value
                                                                }
                                                              );
                                                            })}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            value={getSelectedOption(newGoodsReceivedItem.warehouse_site_id, warehouse_sites)}
                                                            onChange={(e) => handleWarehouseSiteSelect(e.value)}
                                                          />
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <RSelect
                                                            disabled={newGoodsReceivedItem?.warehouse_site_id}
                                                            options={goods_received_categories?.map((p) => {
                                                              return (
                                                                {
                                                                  label: p.label,
                                                                  value: p.value
                                                                }
                                                              );
                                                            })}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            value={getSelectedOption(newGoodsReceivedItem.category, goods_received_categories)}
                                                            onChange={(e) => handleCategorySelect(e.value)}
                                                          />
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <RSelect
                                                            options={goods_received_products?.map((p) => {
                                                              return (
                                                                {
                                                                  label: p.label,
                                                                  value: p.value
                                                                }
                                                              );
                                                            })}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            value={getSelectedOption(newGoodsReceivedItem?.product_id, goods_received_products)}
                                                            onChange={(e) => handleGoodsReceivedCProductSelect(e.value)}
                                                          />
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <RSelect
                                                            options={goods_received_colors?.map((p) => {
                                                              return (
                                                                {
                                                                  label: p.label,
                                                                  value: p.value
                                                                }
                                                              );
                                                            })}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            value={getSelectedOption(newGoodsReceivedItem.color, goods_received_colors)}
                                                            onChange={(e) => handleGoodsReceivedColorSelect(e.value)}
                                                          />
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <RSelect
                                                            options={goods_received_sizes?.map((p) => {
                                                              return (
                                                                {
                                                                  label: p.label,
                                                                  value: p.value
                                                                }
                                                              );
                                                            })}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            value={getSelectedOption(newGoodsReceivedItem.size, goods_received_sizes)}
                                                            onChange={(e) => handleeGoodsReceivedSizeSelect(e.value)}
                                                          />
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <Row className="g-4">
                                                            <TextInput
                                                              required
                                                              type="number"
                                                              min={1}
                                                              disabled={!newGoodsReceivedItem.size}
                                                              value={newGoodsReceivedItem.units}
                                                              colSize="10"
                                                              handleChange={(e) => {
                                                                setNewGoodsReceivedItem({ ...newGoodsReceivedItem, units: e.target.value });
                                                              }}
                                                            />
                                                          </Row>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <Row className="g-4">
                                                            <TextInput
                                                              required
                                                              type="number"
                                                              min={1}
                                                              value={newGoodsReceivedItem.unit_value}
                                                              disabled={!newGoodsReceivedItem.units}
                                                              colSize="10"
                                                              handleChange={(e) => {
                                                                setNewGoodsReceivedItem({ ...newGoodsReceivedItem, unit_value: e.target.value, total_value: parseFloat(e.target.value * newGoodsReceivedItem?.units)?.toFixed(2) });
                                                              }}
                                                            />
                                                          </Row>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <Row className="g-4">
                                                            <TextInput
                                                              required
                                                              type="text"
                                                              disabled
                                                              value={formatNumber(newGoodsReceivedItem.total_value)}
                                                              colSize="10"
                                                            />
                                                          </Row>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <Button color="primary"
                                                            disabled={add_products_to_goods_received_loading || !(newGoodsReceivedItem?.color && newGoodsReceivedItem?.product_name && newGoodsReceivedItem?.product_id && newGoodsReceivedItem?.size && newGoodsReceivedItem?.units && newGoodsReceivedItem?.warehouse_site_id && newGoodsReceivedItem?.unit_value && newGoodsReceivedItem?.total_value && newGoodsReceivedItem?.units > 0)}
                                                            size="sm" onClick={add_products_to_goods_received}>Add</Button>
                                                        </DataTableRow>
                                                      </DataTableItem>
                                                    </>
                                                }
                                              </div>
                                            </Block>
                                          </div>

                                          {/* Modal */}
                                          <Modal isOpen={open_add_products_to_goods_received_confirmation} className="modal-dialog-top">
                                            <ModalHeader
                                              toggle={() => { if (add_products_to_goods_received_loading) { } else { setAddProductsTOGoodsReceivedConfirmation(!open_add_products_to_goods_received_confirmation); } }}
                                            >
                                              Confirm Goods Received
                                            </ModalHeader>
                                            <ModalBody>
                                              <p>
                                                Are you sure that you want to Add these Products to Goods Received?
                                              </p>
                                            </ModalBody>
                                            <ModalFooter className="bg-light">
                                              <BlockBetween>
                                                <BlockHeadContent>
                                                  <Button className={"mx-2"} onClick={() => setAddProductsTOGoodsReceivedConfirmation(!open_add_products_to_goods_received_confirmation)} color="gray">
                                                    No
                                                  </Button>

                                                  <Button className={"mx-2"} onClick={handleAddProductsAndConfirmGoodsReceived} color="primary">
                                                    {add_products_to_goods_received_loading ? <Spinner size="sm" color="light" /> : "Confirm"}
                                                  </Button>
                                                </BlockHeadContent>
                                              </BlockBetween>
                                            </ ModalFooter>
                                          </Modal>
                                        </>
                                      )
                                    }
                                    {
                                      viewGoodsReceivedDetailsActiveCardTab === "History" && (
                                        <>
                                          <div className="card-inner">
                                            <Block>
                                              <BlockHead>
                                                <BlockTitle tag="h5">Goods Received History</BlockTitle>
                                              </BlockHead>
                                              <div className="nk-tb-list is-separate is-medium mb-3">
                                                <DataTableHead className="nk-tb-item">
                                                  <DataTableRow>
                                                    <span className="sub-text">Message</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="lg">
                                                    <span className="sub-text">Timestamp</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span className="sub-text">Action</span>
                                                  </DataTableRow>
                                                </DataTableHead>
                                                {retrieve_goods_received_details_data?.history?.length > 0
                                                  ? retrieve_goods_received_details_data?.history?.map((item) => (
                                                    <DataTableItem key={item.timestamp}>
                                                      <DataTableRow>
                                                        <span className="tb-sub">{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                                                      </DataTableRow>
                                                      <DataTableRow>
                                                        <span className="tb-product">
                                                          <span className="tb-sub">{item?.timestamp ? moment(item?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                        </span>
                                                      </DataTableRow>
                                                      <DataTableRow className="nk-tb-col-tools">
                                                        <div className="tb-odr-btns d-none d-sm-inline">
                                                          <Link to={`/${tenant_info.url_prefix}/products_management/${item?.id}`}>
                                                            <Button color="primary" size="sm" className="btn btn-dim">
                                                              View
                                                            </Button>
                                                          </Link>
                                                        </div>
                                                        <Button className="btn-pd-auto d-sm-none">
                                                          <Icon name="chevron-right"></Icon>
                                                        </Button>
                                                      </DataTableRow>
                                                    </DataTableItem>
                                                  ))
                                                  : null}
                                              </div>
                                            </Block>
                                          </div>
                                        </>
                                      )
                                    }
                                    {
                                      viewGoodsReceivedDetailsActiveCardTab === "PDF" && (
                                        <>
                                          {
                                            retrieve_goods_received_details_data?.status === app_consts.GOODS_RECEIVED_LOWER ?
                                              <>
                                                <div className="card-inner">
                                                  <Block>
                                                    <BlockHead>
                                                      <BlockTitle tag="h5">Goods Received PDF</BlockTitle>
                                                    </BlockHead>
                                                    <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                                      <PDFViewer height="100%" width="100%" showToolbar>
                                                        <GoodsReceivedPDF page_data={retrieve_goods_received_details_data} tenant_info={tenant_info} />
                                                      </PDFViewer>
                                                    </div>
                                                  </Block>
                                                </div>
                                              </>
                                              :
                                              <>
                                                <AuthTenantNoData tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Goods Received is Done Processing"} />
                                              </>
                                          }
                                        </>
                                      )
                                    }
                                  </>
                                  :
                                  <>
                                    <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Goods Received Data Found"} />
                                  </>
                              }
                            </>
                        }
                      </>
                  }

                </ModalBody>
              </Modal>
            </>
        }
      </Content>

    </>
  );
};

export default GoodsReceievedManagement;